module.exports = __webpack_public_path__ + "img/sender-du-ikke-lige-3.32540f87.png";